const LogoutPage = () => {
  (window as any).location = "/api/users/logout";
  // The logout page won't actually render anything since we're
  // redirecting; we should probably find a cleaner way to do this
  return (<div>Logging out...</div>);
};

export default LogoutPage;
